import React from "react";
import { Layout, Menu, Icon, Breadcrumb, Dropdown, Typography } from "antd";
import { Link, withRouter } from "react-router-dom";
import axios from "axios";
import { connect } from "react-redux";
import * as actions from "../../store/actions/auth";
import SubMenu from "antd/lib/menu/SubMenu";
import "./style.css";
import moment from "moment";
import { withTranslation } from "react-i18next";
import {
  BarChartOutlined,
  UsergroupAddOutlined,
  ContactsOutlined,
  CheckSquareOutlined,
  UnorderedListOutlined,
  CalendarOutlined,
  UsergroupDeleteOutlined,
  UserOutlined,
} from "@ant-design/icons";

const { Header, Content, Footer, Sider } = Layout;

class CustomLayout extends React.Component {
  state = {
    collapsed: false,
    branch: { id: 0, name: "Central" },
  };

  componentDidMount() {
    if (!localStorage.getItem("branch")) {
      localStorage.setItem("branch", 0);
    } else {
      const branches = [
        { id: 1, name: "Antibes" },
        { id: 0, name: "Central" },
      ];
      this.setState({
        branch: branches.find(
          (e) => e.id === parseInt(localStorage.getItem("branch"))
        ),
      });
    }
    if (!localStorage.getItem("language"))
      localStorage.setItem("language", "en");
  }

  // componentWillMount() {
  //     axios.defaults.xsrfCookieName = 'csrftoken'
  //     axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
  //     axios.defaults.headers = {
  //         "Content-Type": "application/json",
  // "Accept-Language": localStorage.getItem('language'),
  //     };
  // }

  toggleCollapsed = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  changeLanguage = (lng) => {
    const { i18n } = this.props;
    i18n.changeLanguage(lng);

    const postObj = {
      language_code: lng,
    };

    let token = localStorage.getItem("token");
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.xsrfHeaderName = "X_CSRFTOKEN";
    axios.defaults.headers = {
      "Content-Type": "application/json",
      // "Accept-Language": localStorage.getItem('language'),
      Authorization: `Token ${token}`,
    };

    axios
      .post(process.env.REACT_APP_AXIOS_URL + "/api/language/change/", postObj)
      .then((res) => {
        if (res.status === 200) {
          localStorage.setItem("language", lng);
          moment.updateLocale(lng);
          window.location.reload();
          // this.props.history.push({
          //     pathname: '/login/',
          //     state: { message: this.props.t('auth.password_reset.reset_sent', "Password reset link have been sent to your provided email.") }
          // });
        }
      });
  };

  setBranch = (branch) => {
    localStorage.setItem("branch", `${branch.id}`);
    this.setState({ branch }, () => window.location.reload());
  };

  renderMenu = () => {
    const { branch } = this.state;
    return (
      <Menu selectedKeys={[`${branch.id}`]}>
        <Menu.Item
          key="0"
          onClick={() => this.setBranch({ id: 0, name: "Central" })}
        >
          Central
        </Menu.Item>
        <Menu.Item
          key="1"
          onClick={() => this.setBranch({ id: 1, name: "Antibes" })}
        >
          Antibes
        </Menu.Item>
      </Menu>
    );
  };

  render() {
    const { t } = this.props;
    const { branch } = this.state;

    const breadcrumbNameMap = {
      "/leads": t("layout.menu.leads", "Leads"),
      // '/leads/:leadID': 'Lead information',
      "/contacts": t("layout.menu.contacts", "Contacts"),
      "/tasks": t("layout.menu.tasks", "Tasks"),
      "/tasks/calendar": t("layout.menu.task_calendar", "Tasks calendar"),
      "/events": t("layout.menu.events", "Events"),
      "/events/calendar": t("layout.menu.contact_calendar", "Events calendar"),
      "/profile": t("layout.menu.profile", "Profile"),
      "/email": t("layout.menu.email", "Email"),
      "/services": t("layout.menu.services", "Services"),
    };

    const { location } = this.props;
    const pathSnippets = location.pathname.split("/").filter((i) => i);

    const extraBreadcrumbItems = pathSnippets.map((_, index) => {
      const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;

      return (
        <Breadcrumb.Item key={url}>
          <Link to={url}>
            {breadcrumbNameMap[url] ? breadcrumbNameMap[url] : _}
          </Link>
        </Breadcrumb.Item>
      );
    });
    const breadcrumbItems = [
      <Breadcrumb.Item key="home">
        <Link to="/">{t("layout.menu.home", "Home")}</Link>
      </Breadcrumb.Item>,
    ].concat(extraBreadcrumbItems);

    if (this.props.isAuthenticated === true && this.props.role === "ADMIN") {
      return (
        <Layout style={{ minHeight: "100vh" }}>
          <Sider
            // trigger={null}
            className="sider-shadow"
            collapsible
            collapsed={this.state.collapsed}
            breakpoint="lg"
            // collapsedWidth="80"
            // onBreakpoint={broken => {
            //     console.log(broken);
            // }}
            width="250"
            onCollapse={this.toggleCollapsed}
          >
            <div className="logo">
              <img src={"/static/nerisit-logo-final-light.png"}></img>
            </div>
            <Menu theme="dark" mode="inline" selectedKeys={[location.pathname]}>
              <Menu.Item key="/">
                <BarChartOutlined />
                <span className="nav-text">
                  {t("layout.menu.dashboard", "Dashboard")}
                </span>
                <Link to="/" />
              </Menu.Item>
              <Menu.Item key="/leads">
                <UsergroupAddOutlined />
                <span className="nav-text">
                  {t("layout.menu.leads", "Leads")}
                </span>
                <Link to="/leads" />
              </Menu.Item>
              <Menu.Item key="/contacts">
                <ContactsOutlined />
                <span className="nav-text">
                  {t("layout.menu.contacts", "Contacts")}
                </span>
                <Link to="/contacts" />
              </Menu.Item>
              <SubMenu
                key="subTasks"
                title={
                  <span>
                    <CheckSquareOutlined />
                    <span>{t("layout.menu.tasks", "Tasks")}</span>
                  </span>
                }
              >
                <Menu.Item key="/tasks">
                  <UnorderedListOutlined />
                  <span className="nav-text">
                    {t("layout.menu.list", "List")}
                  </span>
                  <Link to="/tasks" />
                </Menu.Item>
                <Menu.Item key="/tasks/calendar">
                  <CalendarOutlined />
                  <span className="nav-text">
                    {t("layout.menu.calendar", "Calendar")}
                  </span>
                  <Link to="/tasks/calendar" />
                </Menu.Item>
              </SubMenu>
              <SubMenu
                key="subEvents"
                title={
                  <span>
                    <Icon type="mail" />
                    <span>{t("layout.menu.events", "Events")}</span>
                  </span>
                }
              >
                <Menu.Item key="/events">
                  <UnorderedListOutlined />
                  <span className="nav-text">
                    {t("layout.menu.list", "List")}
                  </span>
                  <Link to="/events" />
                </Menu.Item>
                <Menu.Item key="/events/calendar">
                  <CalendarOutlined />
                  <span className="nav-text">
                    {t("layout.menu.calendar", "Calendar")}
                  </span>
                  <Link to="/events/calendar" />
                </Menu.Item>
              </SubMenu>
              {/* <Menu.Item key="6">
                                <Icon type="appstore-o" />
                                <span className="nav-text">{t('layout.menu.users', 'Users')}</span>
                            </Menu.Item> */}
              {/* <Menu.Item key="/email">
                                <Icon type="team" />
                                <span className="nav-text">{t('layout.menu.email', 'Email')}</span>
                                <Link to='/email' />
                            </Menu.Item> */}
              <Menu.Item key="/profile">
                <UserOutlined />
                <span className="nav-text">
                  {t("layout.menu.profile", "Profile")}
                </span>
                <Link to="/profile" />
              </Menu.Item>
              <Menu.Item key="logout" onClick={this.props.logout}>
                <UsergroupDeleteOutlined />
                <span className="nav-text">
                  {t("layout.menu.logout", "Logout")}
                </span>
              </Menu.Item>
            </Menu>
          </Sider>
          <Layout className="site-layout">
            <Header
              className="site-layout-background"
              style={{ background: "#fff", padding: 0 }}
            >
              {/* <Icon
                                className="trigger"
                                type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                                onClick={this.toggleCollapsed}
                                style={{ margin: 20 }}
                            /> */}
              <div style={{ float: "left", marginLeft: "20px" }}>
                <Dropdown overlay={this.renderMenu()} trigger={["click"]}>
                  <Typography.Title
                    type="secondary"
                    style={{ cursor: "pointer", lineHeight: "2.5" }}
                    level={3}
                  >
                    <Icon type="branches" /> {branch.name}
                  </Typography.Title>
                </Dropdown>
              </div>
              <div style={{ float: "right" }}>
                <Dropdown
                  overlay={
                    <Menu>
                      <Menu>
                        <Menu.Item onClick={() => this.changeLanguage("en")}>
                          {t("layout.menu.english", "English")}
                        </Menu.Item>
                        <Menu.Item onClick={() => this.changeLanguage("fr")}>
                          {t("layout.menu.french", "French")}
                        </Menu.Item>
                      </Menu>
                    </Menu>
                  }
                  placement="bottomLeft"
                >
                  <img
                    src="/static/planet.png"
                    width={20}
                    style={{ marginRight: 16 }}
                  />
                </Dropdown>
              </div>
            </Header>
            <Content style={{ margin: "0 16px" }}>
              <Breadcrumb style={{ margin: "8px 0" }}>
                {breadcrumbItems}
              </Breadcrumb>
              <div
                className="site-layout-background"
                style={{ padding: 24, minHeight: 360 }}
              >
                {this.props.children}
              </div>
            </Content>
            <Footer style={{ textAlign: "center" }}>Neris-IT ©2020</Footer>
          </Layout>
        </Layout>
      );
    } else {
      return (
        <Layout>
          {this.props.isAuthenticated ? (
            <React.Fragment>
              <Sider
                className="sider-shadow"
                collapsible
                collapsed={this.state.collapsed}
                breakpoint="lg"
                width="250"
                onCollapse={this.toggleCollapsed}
              >
                <div className="logo">
                  <img src={"/static/nerisit-logo-final-light.png"}></img>
                </div>
                <Menu
                  theme="dark"
                  mode="inline"
                  selectedKeys={[location.pathname]}
                >
                  <Menu.Item key="/">
                    <BarChartOutlined />
                    <span className="nav-text">
                      {t("layout.menu.dashboard", "Dashboard")}
                    </span>
                    <Link to="/" />
                  </Menu.Item>
                  {/* <Menu.Item key="/services">
                                        <Icon type="user" />
                                        <span className="nav-text">Services</span>
                                        <Link to='/services' />
                                    </Menu.Item> */}
                  <Menu.Item key="9" onClick={this.props.logout}>
                    <UsergroupDeleteOutlined />
                    <span className="nav-text">
                      {t("layout.menu.logout", "Logout")}
                    </span>
                  </Menu.Item>
                </Menu>
              </Sider>
              <Layout style={{ minHeight: "100vh" }}>
                <Content style={{ margin: "0 16px" }}>
                  <div
                    className="site-layout-background"
                    style={{ minHeight: 360, padding: 24 }}
                  >
                    {this.props.children}
                  </div>
                </Content>
                <Footer style={{ textAlign: "center" }}>Neris-IT ©2020</Footer>
              </Layout>
            </React.Fragment>
          ) : (
            <Layout style={{ minHeight: "100vh" }}>
              <Content>
                <div
                  className="site-layout-background"
                  style={{ minHeight: 360 }}
                >
                  {this.props.children}
                </div>
              </Content>
              <Footer style={{ textAlign: "center" }}>Neris-IT ©2020</Footer>
            </Layout>
          )}
        </Layout>
      );
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(null, mapDispatchToProps)(withTranslation()(CustomLayout))
);



// WEBPACK FOOTER //
// ./src/containers/Layout/Layout.js